import { isKnownCategory } from "../../utils/guards";
import type { Filters } from "./types";

export const isFilters = (data: unknown): data is Filters => {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const possibleFilters = data as { [key: string]: unknown };

  for (const key in possibleFilters) {
    if (Object.prototype.hasOwnProperty.call(possibleFilters, key)) {
      const value = possibleFilters[key];
      switch (key) {
        case "priceMin":
        case "priceMax":
          if (typeof value !== "number") return false;
          break;
        case "category":
          if (!isKnownCategory(value)) return false;
          break;
        case "city":
        case "cityRange":
        case "search":
        case "sorting":
          if (typeof value !== "string") return false;
          break;
        case "caliber":
        case "shop":
        case "available":
        case "voivodeship":
        case "producer":
        case "excludedPhrases":
          if (!Array.isArray(value) || !value.every((item) => typeof item === "string")) {
            return false;
          }
          break;
        default:
          // Allow extra properties by not returning false
          break;
      }
    }
  }

  return true;
};
